import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import ItemCard from '../itemCard'

import * as styles from './gridVideo.module.css'

const GridVideo = ({
  items,
  viewType,
  videoMuted,
  muteVideo,
  currentSite,
  itemDecorator,
  isHeroItem
}: {
  items: any
  viewType: string
  videoMuted?: boolean
  muteVideo?: () => void
  currentSite: string
  itemDecorator: any
  isHeroItem?: boolean
}) => {
  const listClassName = isHeroItem ? styles.heroItem : styles.result
  const listContainerClassName = isHeroItem
    ? styles.heroItemContainer
    : styles.grid
  return (
    <ul data-test-selector="grid-layout" className={listContainerClassName}>
      {items.map((item: IItem, index: number) => {
        return (
          <li className={listClassName} key={item.id}>
            <ItemCard
              videoMuted={videoMuted}
              muteVideo={muteVideo}
              currentSite={currentSite}
              viewType={viewType}
              itemProps={itemDecorator(item, index)}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default GridVideo
